import React__default from 'react';
import { FormContext } from './FormContext.es.js';
import { Caption } from '../Typography/index.es.js';
import { Col } from '../Grid/Col.es.js';
import { mergeCls } from '../../helpers/utils.es.js';
import styled from '@emotion/styled';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const FormItemInput = (props) => {
  const {
    prefixCls,
    wrapperCol,
    children,
    errors,
    _internalItemRender: formItemRender
  } = props;
  const baseClassName = `${prefixCls}-item`;
  const formContext = React__default.useContext(FormContext);
  const mergedWrapperCol = wrapperCol || formContext.wrapperCol || {};
  const className = mergeCls(`${baseClassName}-control`, mergedWrapperCol.className || "");
  const inputDom = /* @__PURE__ */ React__default.createElement("div", {
    className: `${baseClassName}-control-input`
  }, /* @__PURE__ */ React__default.createElement("div", {
    className: `${baseClassName}-control-input-content`
  }, children));
  const errorDom = !!(errors == null ? void 0 : errors.length) ? /* @__PURE__ */ React__default.createElement(StyledError, {
    marginTop: "s4",
    height: "auto",
    level: 1,
    color: "error500"
  }, errors[0]) : null;
  const dom = formItemRender && formItemRender.render ? formItemRender.render(props, {
    input: inputDom,
    errorList: errorDom || /* @__PURE__ */ React__default.createElement(React__default.Fragment, null)
  }) : /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, inputDom, errorDom);
  return /* @__PURE__ */ React__default.createElement(StyledCol, __spreadProps(__spreadValues({}, mergedWrapperCol), {
    className
  }), dom);
};
const StyledCol = styled(Col)`
  &.teko-form-item-control {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .teko-form-item-control-input {
      display: flex;
      align-items: center;
      .teko-form-item-control-input-content {
        flex: auto;
        max-width: 100%;
      }
    }
  }
`;
const StyledError = styled(Caption)`
  min-height: 16px;
`;
var FormItemInput$1 = FormItemInput;

export { FormItemInput$1 as default };
